import styled, { css } from 'styled-components'

import { UserShort } from '@root/entities/user-short'
import { UserShortAvatar } from '@root/entities/user-short/ui/user-short-avatar'
import { mediaMaxTablet } from '@root/shared/ui-kit'

type ReportUserHeaderProps = {
  user: UserShort.UserShort
}

export const ReportUserHeader: React.FC<ReportUserHeaderProps> = ({ user }) => (
  <Root>
    <Avatar size={60} userShort={user} />
    <UserName>{UserShort.someName(user)}</UserName>
  </Root>
)

const Root = styled.div`
  display: grid;
  gap: 12px;

  place-content: center;
  justify-items: center;
  align-items: center;
  margin-block: 10px 20px;

  ${mediaMaxTablet(css`
    grid-template-columns: auto auto;
    padding: 12px;
    border-radius: 8px;
    background: var(--appearanceA-2);

    margin-block: 0 20px;
  `)}
`

const UserName = styled.div`
  font-weight: 600;
  font-size: 16px;

  ${mediaMaxTablet(css`
    font-size: 14px;
  `)}
`

const Avatar = styled(UserShortAvatar)`
  ${mediaMaxTablet(css`
    width: 36px;
    height: 36px;
  `)}
`
